import { render, staticRenderFns } from "./WanalyzerStatsView.vue?vue&type=template&id=2dcb9089"
import script from "./WanalyzerStatsView.vue?vue&type=script&lang=js"
export * from "./WanalyzerStatsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports